import api from '@/api/index'
import common from '@/components'

const state = {
    file_data:{}
}

const mutations = {
    set_file_data(state,val){
        state.file_data = val
    }
}

const actions = {

}

const getters = {
    file_data(){
        return state.file_data
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
